// extracted by mini-css-extract-plugin
export default {"container":"PinnedIssues-module__container--zhGQR","area":"PinnedIssues-module__area--JvxU0"};